import { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';
import SideBarUl from './SideBarUl';
import { Link } from 'react-router-dom';

const SideBarNav = ({pcSideBarShow, 
                    setPcSideBarShow,
                    mobSideBarShow, 
                    setMobSideBarShow} ) => {
 
    // Стан видимості меню (десктоп і мобільна версії)
    const [ pcSideBarClass, SetPcSideBarClass ] = useState(pcSideBarShow ? 'pc-sidebar' : 'pc-sidebar pc-sidebar-hide');
    const [ mobSideBarClass, SetMobSideBarClass ] = useState(mobSideBarShow ? ' mob-sidebar-active' : '');

    
    // Клік на оверлаї
    const handleOverlayClick = () => {
        setMobSideBarShow(false);
    } 
 
    // ХУк зміни видимості - змінює стилі 
    useEffect(()=>{
        SetPcSideBarClass(pcSideBarShow ? 'pc-sidebar' : 'pc-sidebar pc-sidebar-hide');
        SetMobSideBarClass(mobSideBarShow ? ' mob-sidebar-active' : '');
    },[pcSideBarShow, mobSideBarShow])

    return (
        <>
        <Nav className={`${pcSideBarClass} ${mobSideBarClass}`}>
            <div className="navbar-wrapper">
                <div className="m-header">
                    <Link to="/" >
                    <h3 className='text-primary fw-bold'>eContent</h3>
                    </Link>
                </div>
                <div className="navbar-content pc-trigger simplebar-scrollable-y">
                    <SideBarUl 
                        setMobSideBarShow={setMobSideBarShow}/> 
                </div>
            </div>
        </Nav>  

        {/** оверлай для мобільного меню */}
        {mobSideBarShow && (
        <div className="pc-menu-overlay"
            onClick={handleOverlayClick}></div>
        )}
        </>
    )
}

export default SideBarNav;